// extracted by mini-css-extract-plugin
export default {"card":"BaseCard_card__TCEHN","cardTitle":"BaseCard_cardTitle__rkV52","cardFooter":"BaseCard_cardFooter__8s6xt","cardLink":"BaseCard_cardLink__eMiq5"};